// extracted by mini-css-extract-plugin
module.exports = {"root":"breadcrumbs_root__2fxvt","divider":"breadcrumbs_divider__2UWvk","segment":"breadcrumbs_segment__W7hpf"};